import { PageDto } from '@asset-metrix/portal-gateway-client-js';

import { formatPageFilterUrlValuesForDisplay } from '../components/filter/formatter';
import { FilterConfigDto } from '../store/states/filterTypes';

import { DETAILS_PAGE_URL_DISCRIMINATOR_PARAM } from './constants';

export type DetailsParams = {
  detailsDiscriminator: string | null;
  detailsValue?: string | null;
  detailsLabel?: string | null;
};

export type GetDetailsFromSearchParamsOptions = {
  pageData?: PageDto;
};

function getFilterConfigForDiscriminator(
  detailsDiscriminator: string,
  pageData?: PageDto
): FilterConfigDto | undefined {
  return pageData?.pageFilter?.filters?.find(
    (filter) => filter.key === detailsDiscriminator
  );
}

function formatDetailsLabel(
  detailsParams: string[],
  filterConfig: FilterConfigDto | undefined
): string {
  if (filterConfig != null) {
    return formatPageFilterUrlValuesForDisplay(detailsParams, filterConfig);
  }

  return detailsParams.join(', ');
}

export function getDetailsFromSearchParams(
  searchParams: URLSearchParams,
  options?: GetDetailsFromSearchParamsOptions
) {
  const detailsDiscriminator = searchParams.get(
    DETAILS_PAGE_URL_DISCRIMINATOR_PARAM
  );
  if (detailsDiscriminator == null) {
    return {
      detailsDiscriminator: null,
    };
  }
  const detailsParams = searchParams.getAll(detailsDiscriminator);

  if (detailsParams.length === 0) {
    return {
      detailsDiscriminator,
      detailsValue: null,
      detailsLabel: null,
    };
  }

  const detailsValue = detailsParams.join(',');
  const filterConfig = getFilterConfigForDiscriminator(
    detailsDiscriminator,
    options?.pageData
  );
  const detailsLabel = formatDetailsLabel(detailsParams, filterConfig);

  return {
    detailsDiscriminator,
    detailsValue,
    detailsLabel,
  };
}
